import React from 'react'
import Menubar from '../../Components/menu.jsx';
import SideMenubar from '../../Components/SideMenubar.jsx';
import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { getCookie } from '../../Utils/cookies.js';
import { useNavigate } from 'react-router-dom';
import { use } from 'react';

const Index = () => {
  const Navigate = useNavigate();
  const [ isOpen, setIsOpen ] = React.useState(false);
  useEffect(() => {
    console.log("isOpen in layout", isOpen)
  },[isOpen])
  useEffect(() => {
      const token = getCookie('token');
      const empData = getCookie('empData');
      console.log("token in layout", token)
      if(!token || !empData){
        Navigate('/login');
      }
    }, []);
  return (
    <>
     <div className="outer h-full overflow-y-hidden" >
        <div className="top">
        <Menubar isOpen={isOpen} setIsOpen={setIsOpen} />
        </div>
        <div className="bottom flex flex-row">
          <div className="navigationPart sticky h-full w-[calc(100vw-85vw)] overflow-hidden bg-gray-200">
            <SideMenubar isOpen={isOpen} setIsOpen={setIsOpen} />
          </div>
          <div className="outletPart h-[calc(100vh-5rem)] w-[calc(100vw-15vw)] bg-white overflow-y-auto">
            <Outlet/>
          </div>
        </div>
     </div> 
    </>
  )
}

export default Index
